import WidgetBase from '../widget.base';

export default class MoviesNowPlayingComponent extends WidgetBase {
    static selector = '[data-js-theater-features]';


    constructor(el){
        super(el);        
    }

}